// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"609":"ResultsPageChunk","938":"PlaceholderPageChunk"}[chunkId] || chunkId) + "." + {"214":"257c0cc4","347":"af02d8db","395":"6ae67cef","609":"f7047e54","773":"3de7b9ca","938":"0b627dcc","959":"50b6fbaf"}[chunkId] + ".chunk.js";
};